import React from 'react';

import './feature-send-wire.module.scss';

/* eslint-disable-next-line */
export interface FeatureSendWireProps {}

export function FeatureSendWire(props: FeatureSendWireProps) {
  return (
    <div>
      <h1>Welcome to feature-send-wire!</h1>
    </div>
  );
}

export default FeatureSendWire;
